import React, { useLayoutEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import CveList from 'pages/Search/components/CveList';
import Cvss from 'pages/Search/components/Cvss';
import Database from 'pages/Search/components/Database';
import Products from 'pages/Search/components/Products';
import Vendor from 'pages/Search/components/Vendor';
import Vendors from 'pages/Search/components/Vendors';
import Years from 'pages/Search/components/Years';
import { normalizeUri } from 'pages/Search/utils';

import { ROUTES } from './constants';

const Search = () => {
    useLayoutEffect(
        () =>
            window.history.replaceState(
                null,
                document.title,
                normalizeUri(window.location.pathname, { dedupe: true }).concat(window.location.search)
            ),
        []
    );

    return (
        <Switch>
            <Route exact path={ROUTES.SEARCH()} component={Database} />
            <Route
                exact
                path={[
                    ROUTES.TYPE({ typeName: ':typeName', order: null, page: ':page' }),
                    ROUTES.TYPE({ typeName: ':typeName', order: null, page: null }),
                    ROUTES.TYPE({ typeName: ':typeName', order: ':order(most-viewed)', page: ':page' }),
                    ROUTES.TYPE({ typeName: ':typeName', order: ':order(most-viewed)', page: null })
                ]}
                render={() => <CveList variant="type" />}
            />
            <Route
                exact
                path={[
                    ROUTES.VENDORS({ letter: ':letter', page: ':page' }),
                    ROUTES.VENDORS({ letter: ':letter', page: null }),
                    ROUTES.VENDORS({ letter: null, page: ':page' }),
                    ROUTES.VENDORS({ letter: null, page: null })
                ]}
                component={Vendors}
            />
            <Route
                exact
                path={[
                    ROUTES.VENDOR({ vendorName: ':vendorName', page: ':page' }),
                    ROUTES.VENDOR({ vendorName: ':vendorName', page: null })
                ]}
                component={Vendor}
            />
            <Route
                exact
                path={[
                    ROUTES.VENDOR_CVE({ vendorName: ':vendorName', page: ':page' }),
                    ROUTES.VENDOR_CVE({ vendorName: ':vendorName', page: null })
                ]}
                render={() => <CveList variant="vendor" />}
            />
            <Route
                exact
                path={[
                    ROUTES.PRODUCTS({ letter: ':letter', page: ':page' }),
                    ROUTES.PRODUCTS({ letter: ':letter', page: null }),
                    ROUTES.PRODUCTS({ letter: null, page: ':page' }),
                    ROUTES.PRODUCTS({ letter: null, page: null })
                ]}
                component={Products}
            />
            <Route
                exact
                path={[
                    ROUTES.VENDOR_PRODUCT({ vendorName: ':vendorName', productName: ':productName', page: ':page' }),
                    ROUTES.VENDOR_PRODUCT({ vendorName: ':vendorName', productName: ':productName', page: null })
                ]}
                render={() => <CveList variant="product" />}
            />
            <Route
                exact
                path={[
                    ROUTES.YEARS({ page: ':page', year: ':year', month: ':month' }),
                    ROUTES.YEARS({ page: ':page', year: ':year', month: null }),
                    ROUTES.YEARS({ page: ':page', year: null, month: ':month' }),
                    ROUTES.YEARS({ page: ':page', year: null, month: null }),
                    ROUTES.YEARS({ page: null, year: ':year', month: ':month' }),
                    ROUTES.YEARS({ page: null, year: ':year', month: null }),
                    ROUTES.YEARS({ page: null, year: null, month: ':month' }),
                    ROUTES.YEARS({ page: null, year: null, month: null })
                ]}
                component={Years}
            />
            <Route
                exact
                path={[
                    ROUTES.CVSS({ page: ':page', cvss: ':cvss' }),
                    ROUTES.CVSS({ page: ':page', cvss: null }),
                    ROUTES.CVSS({ page: null, cvss: ':cvss' }),
                    ROUTES.CVSS({ page: null, cvss: null })
                ]}
                component={Cvss}
            />
            <Route path={[ROUTES.TAGS({ tag: ':tag' })]} component={Database} />
            <Route path={'*'} render={() => <Redirect to="/search" />} />
        </Switch>
    );
};

export default Search;
